// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Tpo","wrapper":"styles_wrapper__3Pvd_","btn":"styles_btn__EJyNP","btn-div":"styles_btn-div__1cwMP"};